// extracted by mini-css-extract-plugin
export {};
    if(module.hot) {
      // 1776841920342
      var cssReload = require("/var/jenkins_home/workspace/web-ourchoice-cn-shop/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  